<template>
    <div class="filter weekly-wrapper ms-md-4">
        <div v-if="formattedDateRange" class="date-navigation d-flex mx-auto mx-md-0" id="weekly-date">
            <div>
                <span class="cursor-pointer px-2" @click="backwardNavigation()">
                    <i class="fas fa-chevron-left date-change-icon cursor-pointer"></i>
                </span>
            </div>

            <span class="mx-2 formatted-date">
                {{ formattedDateRange }}
            </span>
            <div>
                <span class="cursor-pointer px-2" @click="forwardNavigation()">
                    <i class="fas fa-chevron-right date-change-icon cursor-pointer"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./WeeklyDateNavigation.ts"></script>
<style src="./WeeklyDateNavigation.scss"></style>
